module.exports = __webpack_public_path__ + "media/images/citrusovy-deodorant-74a0223f184abc2732135d252b5ac396.jpg";